import * as React from "react";

import { Modal } from "src/library/components/Modal";
import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";

import { IList } from "../api/lists.api";

interface IProps {
  show: boolean;
  list: IList;
  onConfirm: () => void;
  handleDismiss: () => void;
  terminology: ITerminology;
}

const CancelListFromModal: React.ReactFCWithChildren<IProps> = ({
  show, onConfirm, handleDismiss, terminology
}) => {
  return (
    <Modal
      small
      type="confirm"
      show={show}
      title={`Delete ${terminology.list.singular.text}`}
      body={`Are you sure you want to remove the ${terminology.list.singular.text}. This action cannot be undone.`}
      actions={[
        {
          name: "Don't Delete",
          action: () => handleDismiss(),
          $buttonType: "secondary"
        },
        {
          name: `Delete ${terminology.list.singular.text}`,
          action: () => {
            onConfirm();
            handleDismiss();
          },
          $buttonType: "primary"
        }
      ]}
      backgroundAction={() => handleDismiss()}
    />
  );
};

export default CancelListFromModal;
